export enum OnboardingEmptyStatesInfoSize {
  Sm = 'onboarding-empty-state-info-sm',
  Md = 'onboarding-empty-state-info-md'
}
